import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import PrintButton from '../Components/PrintButton';
import PersonalDetails from '../Components/PersonalDetails';
import BankDetails from '../Components/BankDetails';
import EducationDetails from '../Components/EducationDetails';
import SignatureSection from '../Components/SignatureSection';
import BankReciept from '../Components/BankReciept';
import AddressDetails from '../Components/AdressDetails';
import Signatures from '../Components/Signatures';
import LogoCollage from "../pages/LogoCollage.jpeg"


const Header = ({ collegeName, logoUrl, course, session }) => (
  <div style={{ textAlign: 'center',padding:"20px 0px" }}>
    <ul style={{
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    }}>
      <li style={{ width: '15%' }}>
        <img src={LogoCollage} style={{ height: '120px', width: '120px' }} alt="College Logo" />
      </li>
      <li style={{ width: '75%' }}>
        <h1>{collegeName}</h1>
         <p style={{ fontSize: '20px', textAlign: 'center' }}>
      <u>ADMISSION FOR THE COURSE OF {course} (Session: {session})</u>
    </p>
      </li>
    </ul>
   
  </div>
);
 
 


const AdditionalDetails = ({ data }) => (
  <div className="more-details">
    <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <li style={{ width: '40%' }}>
        <ul>
          <li>Nationality</li>
          <li>Is Minority</li>
          <li>Is Scholarshiped</li>
          <li>Is Up Residence</li>
          <li>Local Guardian</li>
          <li>Local Gurd. Address</li>
          <li>Local Gurd. Contact</li>
        </ul>
      </li>
      <li style={{ width: '60%' }}>
        <b>
          <ul>
            <li>{data.nationality || 'Indian'}</li>
            <li>{data.is_minority === 1 ? 'Yes' : 'No'}</li>
            <li>{data.has_scholarship === 1 ? 'Yes' : 'No'}</li>
            <li>{data.is_upresidence === 1 ? 'Yes' : 'No'}</li>
            <li>{data.local_guardian || 'N/A'}</li>
            <li>{data.local_guardian_address || 'N/A'}</li>
            <li>{data.local_guardian_contact || 'N/A'}</li>
          </ul>
        </b>
      </li>
    </ul>
  </div>
);
 
 
const SubjectSelection = ({ subjects }) => (
  <div>
    <p style={{ textAlign: 'center' }}>Subject Selection</p>
    <ol>
      <li>M1:{subjects.compulsory_subjects.split(',')[0] || 'N/A'} , M2:{subjects.compulsory_subjects.split(',')[1] || 'N/A'} , Minor:{subjects.compulsory_subjects.split(',')[2] || 'N/A'}</li>
    </ol>
  </div>
);
 
const Declarations = ({ data }) => (
  <div>
    <p style={{ textAlign: 'center' }}>Declarations</p>
    <ol>
      <li>
        <span style={{ width: '90%' }}>
        1.  क्या आपके विरुद्ध कोई अभियोग चल रहा है , चल चुका है किसी अभियोग में दण्डित हो चुके हैं यदि हाँ तो पूर्ण विवरण दें -
        </span>
        <span style={{ width: '10%' }}>{data.is_casefiled === 'yes' ? 'Yes' : 'No'}</span>
      </li>
      <li>
        <span style={{ width: '90%' }}>
        2.  क्या आप गत परीक्षाओं में अनुचित साधन का प्रयोग करते पकड़े गए हैं यदि हाँ तो पूर्ण विवरण दें ।
        </span>
        <span style={{ width: '10%' }}>{data.is_ufmeans === 'yes' ? 'Yes' : 'No'}</span>
      </li>
      <li>
        <span style={{ width: '90%' }}>
        3.  क्या विगत सत्र आपको महाविद्यालय प्रशासन ने अनुशासन भंग करने के कारण चेतावनी दी / निलंबित किया / निष्काषित किया ? यदि हाँ तो पूर्ण विवरण दें गलत जानकारी के लिए प्रवेश पर विचार नहीं किया जाएगा/प्रवेश निरस्त कर दिया जायेगा ।
        </span>
        <span style={{ width: '10%' }}>{data.is_rustigated === 'yes' ? 'Yes' : 'No'}</span>
      </li>
      <li>
        <span style={{ width: '90%' }}>
        4.  क्या आप सेवारत हैं यदि हाँ, तो अपने पद, कार्यालय और नियोजन का उल्लेख करें।
        </span>
        <span style={{ width: '10%' }}>{data.is_civilservant === 'yes' ? 'Yes' : 'No'}</span>
      </li>
      <li>
        <span style={{ width: '90%' }}>
        5.  क्या आपने वर्तमान सत्र में किसी अन्य शिक्षण सस्थान में प्रवेश लिया है यदि हाँ तो उल्लेख करें ।
        </span>
        <span style={{ width: '10%' }}>{data.is_otherenrollment === 'yes' ? 'Yes' : 'No'}</span>
      </li>
    </ol>
  </div>
);
 
 


const RequiredDocuments = () => (
  <div style={{ marginTop: '20px', border: '1px solid black', paddingInline: '20px' }}>
    प्रवेश के समय सभी निम्न वॉछित प्रपत्रों की मूल प्रति लाना अनिवार्य है।
    <p>संलग्नक</p>
    <ol>
      <li>1.हाईस्कूल अंक पत्र एवं प्रमाण पत्र की छायाप्रति |</li>
      <li>2.इंटरमीडिएट अंक पत्र एवं प्रमाण पत्र की छायाप्रति |</li>
      <li>3.निवास प्रमाण पत्र वेरीफिकेशन के साथ | </li>
      <li>4.आधार कार्ड की छायाप्रति ।</li>
      <li>5.जाति प्रमाण पत्र वेरीफिकेशन के साथ, यदि लागू हो की छायाप्रति</li>
      <li>6. आय प्रमाण पत्र वेरीफिकेशन के साथ, यदि लागू हो की छायाप्रति।</li>
       
    </ol>
  </div>
);

// Acknowledgment Component
const Acknowledgment = ({ admissionNumber, studentName, fatherName, course }) => (
  <div style={{ paddingInline: '50px' }}>
    <p style={{ textAlign: 'center' }}><b>Acknowlegment</b></p>
    <br />
    <p>
      Admission for bearing admission number {admissionNumber} received from Mr./Miss/Mrs. {studentName} son {fatherName} class {course}
    </p>
    <br />
    <ul style={{
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: '20px',
      padding: '0px !important'
    }}>
      <li>Date : ..............</li>
      <li>Admission Cell</li>
    </ul>
  </div>
);



 

// Main Component
function AdmissionFormPrint() {
  const { id } = useParams();
  const [data, setData] = useState({});
  
  const loadResult = async () => {
    try {
      const printRes = await axios.post(
        "https://campus.acetians.in/api/v2/admission/print",
        { admission_code: id }
      );
      setData(printRes.data[0]);
    } catch (error) {
      console.error("Error loading admission data:", error);
    }
  };

  useEffect(() => {
    loadResult();
  },[]);

  if (!data || Object.keys(data).length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <> 
    <div className="Admission-Print-Form-Box" style={{padding:'20px',maxWidth:'900px',margin:'auto'}}>
      <PrintButton admissionId={id} />
      
      <Header 
        collegeName="राजकीय महाविद्यालय मिलक रामपुर (उ.प्र.)"
        logoUrl="https://cdn.sanity.io/images/kts928pd/production/c2fcbae1ac2dcdbf24af1e394b95cde0635cbc70-731x731.png"
        course={`${data.part == 1 ? "First Year" : "Second Year"} - ${data.course} `}
        session={data.session}
      />
      
      <PersonalDetails data={data} />
      <AddressDetails 
        currentAddress={data.c_address || 'N/A'} 
        permanentAddress={data.p_address || 'N/A'} 
      />
      <BankDetails
        bankName={data.bank_name || 'N/A'} 
        branchName={data.bank_branch || 'N/A'} 
        accountNumber={data.bank_account || 'N/A'} 
        ifscCode={data.bank_isfsc || 'N/A'} 
      />
      <AdditionalDetails data={data} />
      <EducationDetails data={data} />
      {/* <SubjectSelection subjects={data.compulsory_subjects || 'N/A'} /> */}

      <br/>
      <br/>
      <br/>
      <br/>
      <Declarations data={data} />
      <SignatureSection data={ data } />
      <Signatures data={ data } />
      <RequiredDocuments />
      
      <hr /> 
      
      <Acknowledgment 
        admissionNumber={data.id || 'N/A'} 
        studentName={data.applicant_name || 'N/A'} 
        fatherName={data.father_name || 'N/A'} 
        course={data.course+" First Year"}
      />
      
      <div style={{ margin: 'auto', pageBreakBefore: 'always' }}>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'around',
          listStyle: 'none',
          padding: '0',
          margin: '0 !important'
        }}>
          <li style={{ paddingInline: '10px', borderLeft: '1px solid black', width: '30%' }}>
            <BankReciept copyType="STUDENT" data={data} />
          </li>
          <li style={{ paddingInline: '10px', borderLeft: '1px solid black', width: '30%' }}>
            <BankReciept copyType="COLLEGE" data={data} />
          </li>
          <li style={{ paddingInline: '10px', borderLeft: '1px solid black', width: '30%' }}>
            <BankReciept copyType="BANK" data={data} />
          </li>
        </ul>
      </div>
    </div>
    </>

  );
}

export default AdmissionFormPrint;